export const STREAMSERVE_EVENTS = Object.freeze({
  STREAMING_CONTEXT_CHANGE: 'streamserve:streamingContextChange',
  STREAMING_CONTEXT_REQUEST: 'streamserve:streamingContextRequest',
});
